import { render, staticRenderFns } from "./ObsboxItem.vue?vue&type=template&id=3cd00746&"
import script from "./ObsboxItem.vue?vue&type=script&lang=js&"
export * from "./ObsboxItem.vue?vue&type=script&lang=js&"
import style0 from "./ObsboxItem.vue?vue&type=style&index=0&id=3cd00746&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports